module.exports = __webpack_public_path__ + "static/media/d2.c88fc8f8.png";